module.exports = __webpack_public_path__ + "img/ruina_01.7d543e7a.jpg";